import {action, observable} from 'mobx';

import {Tracker} from '@udemy/event-tracking';

import {PayslipDownloadedEvent} from '../eventtracking/PayslipDownloadedEvent';

export class PayoutStore {
    @observable currentPage = 1;

    @action setCurrentPage(currentPage: number) {
        this.currentPage = currentPage;
    }

    publishPayslipDownloadedEvent() {
        Tracker.publishEvent(new PayslipDownloadedEvent());
    }
}
